export interface HubspotCookieBannerDialogAccessibilityOptions {
  dialogTitle?: string;
}

/**
 * HubSpot injects the EU cookie banner outside React. Apply dialog semantics and
 * a screen-reader title so it meets role="dialog" / aria-modal / heading requirements.
 */
export const applyHubspotCookieBannerDialogAccessibility = (
  banner: HTMLElement,
  { dialogTitle = 'Cookie notice' }: HubspotCookieBannerDialogAccessibilityOptions = {},
): void => {
  if (!banner.id) return;

  const headingId = `${banner.id}-dialog-title`;

  banner.setAttribute('role', 'dialog');
  banner.setAttribute('aria-modal', 'true');
  banner.setAttribute('aria-labelledby', headingId);

  const existingHeading = document.getElementById(headingId);
  if (existingHeading && banner.contains(existingHeading)) {
    if (existingHeading.textContent !== dialogTitle) {
      existingHeading.textContent = dialogTitle;
    }
    return;
  }

  const h1 = document.createElement('h1');
  h1.id = headingId;
  h1.className = 'sr-only';
  h1.textContent = dialogTitle;

  const inner = banner.querySelector('#hs-eu-cookie-confirmation-inner');
  const mountTarget = inner ?? banner;
  mountTarget.insertBefore(h1, mountTarget.firstChild);
};

export const isHubspotCookieBannerVisible = (banner: HTMLElement): boolean => {
  const style = window.getComputedStyle(banner);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  if (Number(style.opacity) === 0) return false;
  return banner.getClientRects().length > 0;
};

export const getVisibleHubspotCookieBanner = (bannerId: string): HTMLElement | null => {
  const banner = document.getElementById(bannerId) as HTMLElement | null;
  if (!banner) return null;
  return isHubspotCookieBannerVisible(banner) ? banner : null;
};
